import { render, staticRenderFns } from "./adjustment-price.vue?vue&type=template&id=d33d487a&scoped=true"
import script from "./adjustment-price.vue?vue&type=script&lang=js"
export * from "./adjustment-price.vue?vue&type=script&lang=js"
import style0 from "./adjustment-price.vue?vue&type=style&index=0&id=d33d487a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33d487a",
  null
  
)

export default component.exports